<button type="button" (click)="handleClick($event)" (keydown.enter)="handleClick($event)" class="card">
  <div class="left-elements">
    @if (entityLoan().name) {
      <div class="loan-name">{{entityLoan().name}}</div>
    }
    @if (!entityLoan().name) {
      <div class="loan-name fallback-text">(Empty)</div>
    }
    <div class="details">
      @if (entityLoan().currency) {
        <div class="loan-currency">{{entityLoan().currency}}</div>
      }
      @if (!entityLoan().currency) {
        <div class="loan-currency fallback-text">(Empty)</div>
      }
    </div>
  </div>
  <div class="right-elements">
    <div class="loan-balance">{{entityLoan().balance.displayValue}}</div>
  </div>
</button>
